export default function Services() {
  const services = ["Web Development", "Cloud", "UI/UX", "API"];

  return (
    <div className="container py-5">
      <h1 className="fw-bold mb-4">Our Services</h1>

      <div className="row g-4">
        {services.map((s, i) => (
          <div key={i} className="col-md-6">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5>{s}</h5>
                <p>Professional solutions tailored for your business.</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
